export default Object.freeze({
    COMPANY_ADMIN: {
        NAME: 'COMPANY_ADMIN',
        VALUE: 'ADMIN',
    },
    COMPANY_USER: {
        NAME: 'COMPANY_USER',
        VALUE: 'USER',
    },
})
